import { Component, Ref, Watch } from 'vue-property-decorator'
import Template from '@/components/BaseCurd/template'
import {
  exportRecord
} from '@/api/api'
import { RepairRecordServiceProxy } from '@/service-proxies/app-v2/tpm.service-proxies'
import { DeviceTypeServiceProxy } from '@/service-proxies/app-v2/workStation.service-proxies'
import AddOrEditForm from './components/AddOrEditForm.vue'
import AttachmentModal from './components/AttachmentModal'
import dayjs from 'dayjs'
import { cloneDeep } from 'lodash'
import { formatTimeSlot } from '@/utils'
import CodeModel from "@/components/CodeModel/index.vue"
import getScrollY from '@/utils/scroll'

const rrsp = new RepairRecordServiceProxy()
const dpsp = new DeviceTypeServiceProxy()

@Component({
  AddOrEditForm,
  CodeModel
})
export default class RepairRecord extends Template {
  @Ref() readonly _form_add: typeof AddOrEditForm
  @Ref() readonly _form_edit: typeof AddOrEditForm
  // 维修记录
  name = 'RepairRecord'
  options = {
    retrieve: rrsp.getPageRepairApply.bind(rrsp),
    search: rrsp.getApplyDetail.bind(rrsp),
    create: rrsp.createRepairApply.bind(rrsp),
    update: rrsp.updateRepairApply.bind(rrsp),
    delete: null
  }
  acl = {
    create: 'page_tpm_repair_add_repair_record',
    update: 'page_tpm_repair_edit_record',
    delate: '',
    confirm: 'page_tpm_repair_confirm_apply', // 确认申请单
    export: 'page_tpm_repair_export_repair_record' // 导出维修记录
  }
  ie = true
  waitGetData = true
  // exportFilename = this.$t('page_repair_record') + '.xlsx'
  exportFilename = '维修记录.xlsx'
  exportFn = this.handleExport
  showCode=false
  dataListArr=[]
  // deviceTypeList = []
  deviceTypes = []
  deviceTypeId = ''
  recordStatus = 0
  attachVisible = false // 附件模态框
  attachmentInfo: any = {} // 附件信息
  attachType = 1 // 1临时，2例行


  get lang() {
    return {
      create: this.$t('page_tpm_repair_add_repair_record'),
      placeholder: this.$t('keyword'),
      search: this.$t('search'),
      edit: this.$t('edit'),
      delete: this.$t('page_business_delete_material'),
      viewAttachment: this.$t('page_tpm_check_watch_file')
    }
  }

  get urgencyMap() {
    return {
      1: this.$t('page_tpm_repair_low'),
      2: this.$t('page_tpm_repair_middle'),
      3: this.$t('page_tpm_repair_high')
    }
  }

  get recordStatusMap() {
    return {
      1: this.$t('page_tpm_repair_to_be_confirmed'),
      2: this.$t('page_tpm_repair_confirmed')
    }
  }

  get recordStatusList() {
    return [
      { label: this.$t('page_tpm_repair_all'), value: 0 },
      { label: this.$t('page_tpm_repair_to_be_confirmed'), value: 1 },
      { label: this.$t('page_tpm_repair_confirmed'), value: 2 }
    ]
  }

  get deviceTypeList() {
    return [{ label: this.$t('page_plan_maintenance_all_types'), value: '' }, ...this.deviceTypes]
  }

  @Watch('deviceTypeList')
  handleDeviceTypesChange(val) {
    if (val.length) {
      this.deviceTypeId = val[0].value
    }
  }

  @Watch('deviceTypeId', { immediate: true })
  handleTypeIdChange(val) {
    this.dataSource = []
    this.filters = {
      total: 0,
      size: 30,
      current: 1
    }
    this.getData()
  }

  created() {
    this.getDeviceTypeList()
    this.scroll['x'] = 1200
  }

  async getDeviceTypeList() {
    let params: any = {
      keyWord: '',
      query: {
        current: 1,
        size: -1
      }
    }
    let res = await dpsp.pageDeviceType(params)
    this.deviceTypes = res.records.map(item => ({ label: item.name, value: item.id }))
  }

  async getData(
    current = this.filters.current,
    size = this.filters.size,
    keyWords = this.keywords,
    reload: any = false
  ) {
    if (reload) current = 1
    const fetchFn = this.options.retrieve

    let params = {
      deviceTypeId: this.deviceTypeId,
      filterPlus: false, // 是否高级筛选
      keyWords,
      param: undefined,
      recordStatus: this.recordStatus ? this.recordStatus : ''
    }

    const { records, total: t, size: s, current: c } = await fetchFn(
      current,
      params,
      size
    )
    // this.dataSource = records
    
    let dataLength = records.length;
      let copy = JSON.parse(JSON.stringify(records));
      let needPush = 0;
      if(dataLength < 30) {
        needPush = 30 - dataLength;
        for(var k=0; k<needPush; k++) {
          let obj = {  
            // id: 'none'
          }
          copy.push(obj)  
        }
      }  
      this.dataSource = JSON.parse(JSON.stringify(copy));

      this.scroll['y'] = getScrollY('repair-record-table',this.dataSource.length)

    this.filters = {
      total: Number(t),
      size: Number(s),
      current: Number(c)
    }

    // 改变申请单状态后刷新数据
    if (this.selectedRows.length) {
      this.dataSource.map(item => {
        this.selectedRows.map(ite => {
          if (item.id === ite.id) {
            ite.recordStatus = item.recordStatus
          }
        })
      })
      this.selectedRows = cloneDeep(this.selectedRows)
    }
    // 选中项不在当前页时清空checkbox选中（选中多条时不影响）
    /*    if (this.selectedRowKeys.length === 1 && this.dataSource.findIndex(item => item.id === this.selectedRowKeys[0]) < 0) {
          this.selectedIds = []
          this.selectedRows = []
          this.selectedRowKeys = []
        }*/

    // 选中项不在当前页时清空checkbox选中
    let temp = cloneDeep(this.selectedRowKeys)
    temp.reverse().map((selected, index, arr) => {
      if (this.dataSource.findIndex(item => item.id === selected) < 0) {
        let del = arr.length - index - 1
        this.selectedIds.splice(del, 1) // 勾选的数据项集合
        this.selectedRows.splice(del, 1) // 勾选的数据项集合
        this.selectedRowKeys.splice(del, 1)// 勾选的key值集合
      }
    })
  }

  async handleExport(type) {
    let params = {
      exportSelected: !!(this.selectedIds.length),
      selectedRecords: this.selectedIds,
      recordStatus: this.recordStatus ? this.recordStatus : '',
      deviceId: '',
      deviceTypeId: this.deviceTypeId,
      keyWord: this.keywords
    }
    if (type === 'select') {
      Object.assign(params, {exportSelected: true})
    } else {
      Object.assign(params, {exportSelected: false })
    }
    return await exportRecord(params)
  }

  render() {
    return this.customRender()
  }

  extraHeaderAction() {
    return [
      <export-button
        multi={true}
        filename={this.exportFilename}
        exportFn={this.handleExport}
        disabled={!(this.dataSource.length)}
        selectedKeys={this.selectedIds}
        style="margin-left: 8px"
      />
    ]
  }

  renderHeader() {
    return (
      <div
        slot="action"
        style={{
          display: 'flex',
          justifyContent: 'space-between'
        }}
      >
        <div>
          <a-button
            v-acl={this.acl.create}
            type="primary"
            style={{ marginRight: '8px' }}
            onClick={this.openCreateWindow}
          >
            {this.lang.create}
          </a-button>
          <a-button
            v-acl={this.acl.update}
            type="default"
            style={{ marginRight: '8px' }}
            onClick={() => this.openEditWindow(this.selectedRows[0])}
            disabled={this.selectedIds.length !== 1 || this.selectedRows[0].recordStatus !== 1}
          >
            {this.lang.edit}
          </a-button>
          <a-button  onClick={()=>this.printing()} disabled={this.selectedRowKeys.length === 0}>{this.$t("page_print_code")}</a-button>
            {/* 打印按钮 */}
          {this.ie ? this.extraHeaderAction() : null}
        </div>
        <div>
          <app-select list={this.deviceTypeList} v-model={this.deviceTypeId} onChangeSelect={this.handleTypeChange}/>
          <app-select list={this.recordStatusList} v-model={this.recordStatus}
                      onChangeSelect={this.handleRecordStatusChange}/>
          <a-input-search
            placeholder={this.lang.placeholder}
            onSearch={this.onSearch}
            enterButton={this.lang.search}
            allowClear={true}
            style="width: auto!important;"
            v-model={this.keywords}
          />

          <CodeModel visible={this.showCode}  onCancel={()=>this.cancel()} dataList={this.dataListArr}/>
        </div>
      </div>
    )
  }
  printing(){
    //控制打印显隐
    this.getList()
    this.showCode=true
  }
  getList() {
    //重组拿到的数据，分为code和name
    this.dataListArr = []
    this.selectedRowKeys.map(id =>{
      this.dataSource.map(item => {
        if(id === item.id) {
          this.dataListArr.push({
            code: item.applyCode,
            name: item.deviceName
          })
        }
      })
    })
  }
  cancel(){
    //打印消失
    this.showCode=false
  }
  handleTypeChange(value) {
    this.filters = {
      total: 0,
      size: 30,
      current: 1
    }
    this.deviceTypeId = value
  }

  handleRecordStatusChange(value) {
    this.filters = {
      total: 0,
      size: 30,
      current: 1
    }
    this.recordStatus = value
    this.dataSource = []
    this.filters = {
      total: 0,
      size: 30,
      current: 1
    }
    this.getData()
  }

  // 查看附件
  async viewAttachment(record) {
    this.changeRow(record)
    this.onSelectChange([record.id], [record])
    this.attachVisible = true
    this.attachType = record.recordType
    this.attachmentInfo = await rrsp.getRecordFile(record.id)
  }

  closeAttachmentModal() {
    this.attachVisible = false
  }

  // 确认维修申请单
  async ok(record) {
    this.changeRow(record)
    this.onSelectChange([record.id], [record])
    let res = await rrsp.implementRepairRecord(record.id)
    if (res) {
      this.$message.success(this.$t('page_resource_pool_success'))
      this.getData()
    }
  }

  // 行点击
  rowClick(record) {
    return {
      on: {
        click: (event: any) => {
          this.selectedRowKeys = []
          this.selectedIds = []
          this.selectedRows = []
          this.selectedRowKeys.push(record.id)
          this.selectedIds.push(record.id)
          this.selectedRows.push(record)
          this.selectRowKey = record.id
        },
      },
    }
  }

  // 点击表格中的操作按钮时切换选中行
  changeRow(record) {
    this.selectRowKey = record.id
  }

  get columns() {
    return [
      {
        title: this.$t('actions'),
        dataIndex: 'action',
        key: 'action',
        width: 150,
        ellipsis: true,
        customRender: (sort, _record, index) => {
          return (
            _record.id &&
            <div>
              <a
                type="link"
                onClick={(e) => {
                  e.stopPropagation()
                  this.viewAttachment(_record)
                }}
              >
                {this.$t('page_tpm_check_watch_file')}
              </a>
              <a-divider type="vertical" style={{ visibility: _record.recordStatus !== 1 ? 'hidden' : 'visible' }}/>
              <a
                type="link"
                onClick={(e) => {
                  e.stopPropagation()
                  this.ok(_record)
                }}
                style={{ visibility: _record.recordStatus !== 1 ? 'hidden' : 'visible' }}
              >
                {this.$t('page_workstation_maintain_sure')}
              </a>
            </div>
          )
        }
      },
      /* {
         title: this.$t('page_resource_pool_no'), dataIndex: 'order', width: 80, ellipsis: true,
         customRender: (val, record, arr) => (arr + 1)
       },*/
      { title: this.$t('page_plan_maintenance_task_number'), dataIndex: 'recordCode', width: 100, ellipsis: true },
      {
        title: this.$t('page_plan_maintenance_application_form_status'),
        dataIndex: 'recordStatus',
        width: 100,
        ellipsis: true,
        customRender: (text) => this.recordStatusMap[text]
      },
      {
        title: this.$t('page_tpm_repair_type'), dataIndex: 'recordType', width: 100, ellipsis: true,
        customRender: (text,record) => {
          if(record.id) {
            return text === 1 ? this.$t('page_tpm_repair_temporary_repairs') : this.$t('page_tpm_repair_routine_maintenance')
          }
        }
      },
      { title: this.$t('page_plan_maintenance_application_No'), dataIndex: 'applyCode', width: 100, ellipsis: true },
      { title: this.$t('page_plan_maintenance_equipment_coding'), dataIndex: 'deviceCode', width: 100, ellipsis: true },
      { title: this.$t('page_plan_maintenance_equipment_name'), dataIndex: 'deviceName', width: 100, ellipsis: true },
      {
        title: this.$t('page_plan_maintenance_equipment_type'),
        dataIndex: 'deviceTypeName',
        width: 100,
        ellipsis: true
      },
      // { title: this.$t('规格型号'), dataIndex: 'code', width: 100, ellipsis: true },
      { title: this.$t('page_tpm_repair_apply_person'), dataIndex: 'applyUserName', width: 100, ellipsis: true },
      { title: this.$t('page_tpm_repair_error_code'), dataIndex: 'errorCode', width: 100, ellipsis: true },
      {
        title: this.$t('page_tpm_repair_apply_time'), dataIndex: 'applyTime', width: 150, ellipsis: true,
        customRender: (text) => (text ? dayjs(text).format('YYYY-MM-DD HH:mm:ss') : '')
      },
      {
        title: this.$t('page_tpm_repair_occurrence_time'), dataIndex: 'malfunctionTime', width: 150, ellipsis: true,
        customRender: (text) => (text ? dayjs(text).format('YYYY-MM-DD HH:mm:ss') : '')
      },
      {
        title: this.$t('page_tpm_repair_urgency'), dataIndex: 'urgency', width: 100, ellipsis: true,
        customRender: (text) => this.urgencyMap[text]
      },
      {
        title: this.$t('page_tpm_repair_start_time'), dataIndex: 'repairStartTime', width: 150, ellipsis: true,
        customRender: (text) => (text ? dayjs(text).format('YYYY-MM-DD HH:mm:ss') : '')
      },
      {
        title: this.$t('page_tpm_repair_end_time'), dataIndex: 'repairEndTime', width: 150, ellipsis: true,
        customRender: (text) => (text ? dayjs(text).format('YYYY-MM-DD HH:mm:ss') : '')
      },
      {
        title: this.$t('page_tpm_repair_time'), dataIndex: 'repairTime', width: 100, ellipsis: true,
        customRender: (text) => text ? formatTimeSlot(text) : ''
      },
      { title: this.$t('page_tpm_repair_person'), dataIndex: 'repairUserName', width: 100, ellipsis: true },
      { title: this.$t('page_extranet_Fault_description'), dataIndex: 'description', width: 100, ellipsis: true },
      { title: this.$t('page_tpm_repair_fault_analysis'), dataIndex: 'malfunctionDetails', width: 100, ellipsis: true }
    ]
  }

  renderDialog() {
    return (
      <a-modal
        class={this.templateModalClass}
        onCancel={() => (this.showDialog = false)}
        title={this.$t('page_tpm_repair_add_repair_record')}
        visible={this.showDialog}
        destroyOnClose={true}
        maskClosable={false}
        width={1000}
      >
        <div slot="footer">
          <a-button
            style="margin-right:8px"
            onClick={() => (this.showDialog = false)}
          >
            {this.$t('cancel')}
          </a-button>
          <a-button type="primary" onClick={this.createData} loading={this.saveLoading}>
            {this.createModalSaveBtn}
          </a-button>
        </div>
        <AddOrEditForm ref='_form_add' visible={this.showDialog} deviceTypeId={this.deviceTypeId} type="add"/>
      </a-modal>
    )
  }

  async createData() {
    let form: any = this._form_add
    let data: any = await form.getAllData()
    if (!data) {
      return
    }
    // const data: any = await this._form_add.manualSubmit()
    this.saveLoading = true
    const fetchFn = this.options.create
    try {
      await fetchFn(data)
      this.saveLoading = false
      this.$message.success(this.$t('page_docdirectory_create_success'))
      this.showDialog = false
      this.getData()
    } catch (e) {
      this.saveLoading = false
    }
  }

  async updateData() {
    let form: any = this._form_edit
    let values: any = await form.getAllData()
    if (!values) {
      return
    }
    this.saveLoading = true
    const data = {
      ...this.editdata,
      ...values
    }
    for (let key in data) {
      if (typeof data[key] === 'undefined') {
        data[key] = ''
      }
    }
    const fetchFn = this.options.update
    try {
      await fetchFn(data)
      this.saveLoading = false
      this.$message.success(this.$t('page_docdirectory_edit_success'))
      this.showDrawer = false
      this.getData()
    } catch (e) {
      this.saveLoading = false
    }
  }

  /*编辑*/
  renderDrawer() {
    return (
      <a-modal
        className={this.templateModalClass}
        onCancel={() => (this.showDrawer = false)}
        title={this.$t('page_tpm_repair_edit_record')}
        visible={this.showDrawer}
        destroyOnClose={true}
        maskClosable={false}
        width={1000}
      >
        <div slot="footer">
          <a-button
            style="margin-right:8px"
            onClick={() => (this.showDrawer = false)}
          >
            {this.$t('cancel')}
          </a-button>
          <a-button type="primary" onClick={this.updateData} loading={this.saveLoading}>
            {this.$t('save')}
          </a-button>
        </div>
        <AddOrEditForm ref="_form_edit" visible={this.showDrawer} deviceTypeId={this.deviceTypeId}
                       editData={this.editdata} type="edit"/>
      </a-modal>
    )
  }

  customRender() {
    return (
      <blank-view>
        {this.renderHeader()}
        <div id="repair-record-table" style="height:100%">
          {this.renderBody()}
          {this.renderDialog()}
          {this.renderDrawer()}
          <AttachmentModal visible={this.attachVisible} attachType={this.attachType} data={this.attachmentInfo}
                           onClose={this.closeAttachmentModal}/>
        </div>
      </blank-view>
    )
  }

}
